import { useEffect, useRef } from 'react';

import { useEditCanvasStore } from '../../store';

export function useSpacebarPan() {
  const canvasMode = useEditCanvasStore((state) => state.canvasMode);

  const isEligible = canvasMode.mode === 'default';
  const spaceActivatedRef = useRef(false);

  useEffect(() => {
    if (!isEligible) {
      return;
    }

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.code !== 'Space' || e.repeat) {
        return;
      }
      const target = e.target;

      if (!(target instanceof HTMLElement)) {
        return;
      }
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return;
      }
      if (useEditCanvasStore.getState().activeTool !== 'select') {
        return;
      }
      spaceActivatedRef.current = true;
      // Set activeTool directly to avoid setActiveTool's side effect of clearing node selection.
      // Spacebar pan is a temporary gesture — selection must be preserved.
      useEditCanvasStore.setState({ activeTool: 'hand' });
    };

    const restoreTool = () => {
      if (spaceActivatedRef.current) {
        spaceActivatedRef.current = false;
        useEditCanvasStore.setState({ activeTool: 'select' });
      }
    };

    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.code !== 'Space') {
        return;
      }
      restoreTool();
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    window.addEventListener('blur', restoreTool);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('blur', restoreTool);
      restoreTool();
    };
  }, [isEligible]);
}
